import { URI } from '@/config/config';

export default async ({ rootState }, zoneId) => {
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const parksResult = await fetch(`${URI}zones/${zoneId}`, opts);
  const jsonResult = await parksResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
